
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asuransi-cicilan-kredit",
      function () {
        return require("private-next-pages/asuransi-cicilan-kredit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asuransi-cicilan-kredit"])
      });
    }
  